import React, { useEffect, useState } from 'react';
import {
  Dimensions,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
  TextInput,
  FlatList,
  TouchableOpacity,
  ScrollView,
  Modal
} from 'react-native';
import { Picker } from '@react-native-picker/picker';
import axios from 'axios';
import { Formik } from 'formik';
import * as yup from 'yup';

import { BASE_URL } from '../../../components/BaseUrl';
import LeftBar from '../../../shared/LeftBar';
import LeftBarItem from '../../../shared/LeftBarItem';
import ErrorText from '../../../shared/errorText';
import { globalStyles } from '../../../styles/globalStyles';
import SearchForm from './../../../components/BookmarkList/SearchForm';

const windowWidth = Dimensions.get('window').width;

const basicInfoSchema = yup.object({
  division_name: yup.string().required('Division is required'),
  district_name: yup.string().required('District is required'),
  lower_court_name: yup.string().required('Lower Court is required'),
});
const basicInfoSearchSchema = yup.object({
  division_name: yup.string().required('Division is required'),
  district_name: yup.string().required('District is required'),
});

export const GrBranchAdalotComponent = () => {
  const [division, setDivision] = useState([]);
  const [district, setDistrict] = useState([]);
  const [lowerCourt, setLowerCourt] = useState([]);

  const [division_id, setDivisionId] = useState('');
  const [district_id, setDistrictId] = useState('');
  const [searchDivision_id, setSearchDivisionId] = useState('');
  const [searchDistrict_id, setSearchDistrictId] = useState('');
  const [searchDivisionName, setSearchDivisionName] = useState('');
  const [searchDistrict_name, setSearchDistrictName] = useState('');
  const [thana_id, setThanaId] = useState('');
  const [lower_court_id, setLowerCourtId] = useState('');
  const [selectedLowerCourt, setSelectedLowerCourt] = useState(null);
  const [allData, setAllData] = useState([]);

  // State for edit modal
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editDivisionId, setEditDivisionId] = useState('');
  const [editDistrictId, setEditDistrictId] = useState('');
  const [editLowerCourtName, setEditLowerCourtName] = useState('');
  const [editDistrictData, setEditDistrictData] = useState([]);

  useEffect(() => {
    handleGetAllData();
    fetchDivisionData();
  }, []);

  const fetchDivisionData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/GetDivission`);
      setDivision(res.data || []);
    } catch (error) {
      console.log('Division Error:', error);
    }
  };

  const fetchDistrictData = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;

      const res = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      setDistrict(res.data || []);
      setDistrictId('');
      setThanaId('');
      setLowerCourtId('');
      setLowerCourt([]);
      setSelectedLowerCourt(null);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchEditDistrictData = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;

      const res = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      setEditDistrictData(res.data || []);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchLowerCourtData = async districtId => {
    try {
      const formBody = `geo_district_id=${encodeURIComponent(
        districtId,
      )}&geo_division_id=${encodeURIComponent(division_id)}`;

      const res = await axios.post(
        `${BASE_URL}/DivisionAndDistrictToCourtName`,
        formBody,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      );

      setLowerCourt(res.data || []);
      setThanaId('');
      setLowerCourtId('');
      setSelectedLowerCourt(null);
    } catch (error) {
      console.log('Lower Court Error:', error);
    }
  };

  const handleGetAllData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/GetGrbranchByDivisionAndDistrict`);
      if (res.status == 200) {
        setAllData(res.data);
      }
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  }

  const handleSearch = async () => {
    if (!searchDivision_id || !searchDistrict_id) {
      alert('Please select both division and district to search');
      return;
    }
    try {
      const res = await axios.get(`${BASE_URL}/GetGrbranchByDivisionAndDistrict`, {
        params: {
          geo_division_id: searchDivision_id,
          geo_district_id: searchDistrict_id,
        },
      });
      console.log('Search Response:', res);
      if (res.status == 200) {
        setAllData(res.data);
      }
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  }

  const handleSubmitForm = async () => {
    const payload = {
      name_bng: lower_court_id || '',
      geo_division_id: division_id,
      geo_district_id: district_id,
      status: 1,
    };

    if (!payload.name_bng && !payload.geo_division_id && !payload.geo_district_id) {
      console.log('No lower court selected');
      return;
    }

    let formBody = [];
    for (let key in payload) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(payload[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }

    formBody = formBody.join('&');
    let url = `${BASE_URL}/GrbranchCreate`;

    try {
      let response = await axios.post(url, formBody);
      alert("Data added successfully");
      handleGetAllData();

      // Reset form fields
      setDivisionId('');
      setDistrictId('');
      setLowerCourtId('');

    } catch (error) {
      console.log('Submit Error:', error?.response?.data || error.message);
      alert("Error adding data");
    }
  };

  const handleUpdateStatus = async item => {
    const updatedStatus = item.status === 1 ? 0 : 1;
    try {
      let url = `${BASE_URL}/GrbranchUpdateStatus/?status=${updatedStatus}&id=${item.id}`;
      let response = await axios.post(url);
      alert("Status updated successfully");
      handleGetAllData();
    } catch (error) {
      console.log('Update Error:', error);
      alert("Error updating status");
    }
  }

  const handleEditData = async (item) => {
    setIsEditModalVisible(true);
    setEditId(item.id);
    setEditDivisionId(item.geo_division_id?.toString());
    setEditLowerCourtName(item.name_bng?.toString());

    // Fetch districts for the selected division
    await fetchEditDistrictData(item.geo_division_id?.toString());
    setEditDistrictId(item.geo_district_id?.toString());
  }

  const handleUpdateData = async () => {
    if (!editLowerCourtName || !editDivisionId || !editDistrictId) {
      alert('Please fill all fields');
      return;
    }

    const payload = {
      id: editId,
      name_bng: editLowerCourtName || '',
      geo_division_id: editDivisionId,
      geo_district_id: editDistrictId,
      status: 1,
    };

    let formBody = [];
    for (let key in payload) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(payload[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }

    formBody = formBody.join('&');

    try {
      let url = `${BASE_URL}/GrbranchUpdate`;
      let response = await axios.post(url, formBody);
      alert("Data updated successfully");
      setIsEditModalVisible(false);
      handleGetAllData();

      // Reset edit states
      setEditId(null);
      setEditDivisionId('');
      setEditDistrictId('');
      setEditLowerCourtName('');
      setEditDistrictData([]);

    } catch (error) {
      console.log('Update Error:', error);
      alert("Error updating data");
    }
  }

  const renderItem = ({ item, index }) => {
    return (
      <View style={styles.card}>
        <Text style={styles.serial}>{index + 1}.</Text>

        <View style={[styles.content]}>
          <Text style={styles.name}>{item.name_bng}</Text>
          <TouchableOpacity onPress={() => handleUpdateStatus(item)}>
            <Text
              style={[
                styles.status,
                {
                  color: item.status === 1 ? '#16a34a' : '#dc2626',
                },
              ]}>
              {item.status === 1 ? 'Active' : 'Inactive'}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => handleEditData(item)}>
            <Text
              style={[
                styles.status,
                {
                  color: '#f5a905',
                },
              ]}>
              Edit
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  return (
    <ScrollView>
      <View
        style={
          Platform.OS === 'web' && windowWidth >= 600
            ? globalStyles.mainContainerAdmin
            : globalStyles.mainContainerMobile
        }>
        <LeftBar>
          <LeftBarItem
            selectcolor="true"
            name="ড্যাসবোর্ড"
            stack="Dashboard"
            screen="DashboardScreen"
          />
          <LeftBarItem
            selectcolor="true"
            name="জি আর শাখা আদালত"
            stack="অ্যাডমিন"
            screen="grBranchAdalot"
          />
           <LeftBarItem
                      selectcolor="true"
                      name="জি আর  থানা / অঞ্চল " 
                      stack="অ্যাডমিন"
                      screen="grThanaArea"
          />
          
           <LeftBarItem selectcolor='true' name='জি আর আদালত যোগ' stack='অ্যাডমিন' screen='grAdalotCreate' />
        </LeftBar>

        <View
          style={
            Platform.OS === 'web' && windowWidth >= 600
              ? globalStyles.bodyContainer
              : globalStyles.bodyContainerMobile
          }>
          <Formik
            initialValues={{
              division_name: '',
              district_name: '',
              lower_court_name: '',
            }}
            validationSchema={basicInfoSchema}
            onSubmit={handleSubmitForm}>
            {({
              handleChange,
              handleSubmit,
              setFieldTouched,
              touched,
              errors,
            }) => (
              <>
                <View style={styles.formWrapper}>
                  {/* Division */}
                  <View style={styles.FormGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={division_id || ''}
                        style={styles.picker}
                        onValueChange={itemValue => {
                          setDivisionId(itemValue);
                          fetchDistrictData(itemValue);
                          handleChange('division_name')(itemValue);
                          setFieldTouched('division_name', true);
                        }}
                        mode="dropdown">
                        <Picker.Item
                          label="বিভাগ নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {division.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.division_name_bng?.toString()}
                            value={item.geo_division_id?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.division_name && errors.division_name ? (
                      <ErrorText>{errors.division_name}</ErrorText>
                    ) : null}
                  </View>

                  {/* District */}
                  <View style={styles.FormGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={district_id || ''}
                        style={styles.picker}
                        onValueChange={itemValue => {
                          setDistrictId(itemValue);
                          fetchLowerCourtData(itemValue);
                          handleChange('district_name')(itemValue);
                          setFieldTouched('district_name', true);
                        }}
                        mode="dropdown">
                        <Picker.Item
                          label="জেলা নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {district.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.district_name_bng?.toString()}
                            value={item.geo_district_id?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.district_name && errors.district_name ? (
                      <ErrorText>{errors.district_name}</ErrorText>
                    ) : null}
                  </View>

                  {/* Lower Court Input */}
                  <View style={styles.FormGroup}>
                    <View style={styles.inputWrapper}>
                      <TextInput
                        placeholder="অধস্তন আদালত লিখুন"
                        placeholderTextColor="#999"
                        style={styles.textInput}
                        value={lower_court_id}
                        onChangeText={text => {
                          setLowerCourtId(text);
                          handleChange('lower_court_name')(text);
                          setFieldTouched('lower_court_name', true);
                        }}
                      />
                    </View>
                    {touched.lower_court_name && errors.lower_court_name ? (
                      <ErrorText>{errors.lower_court_name}</ErrorText>
                    ) : null}
                  </View>

                  <Pressable style={styles.submitButton} onPress={handleSubmit}>
                    <Text style={styles.submitButtonText}>Add</Text>
                  </Pressable>
                </View>
              </>
            )}
          </Formik>

          <View style={styles.wrapper}>
            <Formik
              initialValues={{
                division_name: '',
                district_name: '',
              }}
              validationSchema={basicInfoSearchSchema}
              onSubmit={handleSearch}>
              {({
                handleChange,
                handleSubmit,
                setFieldTouched,
                touched,
                errors,
              }) => (
                <>
                  <View style={[styles.formWrapper, {
                    paddingVertical: 0,
                    paddingHorizontal: 0,
                    borderRadius: 0,
                    borderWidth: "none",
                  }]}>
                    {/* Division */}
                    <View style={styles.FormGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchDivision_id || ''}
                          style={styles.picker}
                          onValueChange={itemValue => {
                            setSearchDivisionId(itemValue);
                            fetchDistrictData(itemValue);
                            handleChange('division_name')(itemValue);
                            setFieldTouched('division_name', true);
                          }}
                          mode="dropdown">
                          <Picker.Item
                            label="বিভাগ নির্বাচন করুনঃ–"
                            value=""
                            color="red"
                          />
                          {division.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.division_name_bng?.toString()}
                              value={item.geo_division_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.division_name && errors.division_name && !searchDivision_id ? (
                        <ErrorText>{errors.division_name}</ErrorText>
                      ) : null}
                    </View>

                    {/* District */}
                    <View style={styles.FormGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchDistrict_id || ''}
                          style={styles.picker}
                          onValueChange={itemValue => {
                            setSearchDistrictId(itemValue);
                            fetchLowerCourtData(itemValue);
                            handleChange('district_name')(itemValue);
                            setFieldTouched('district_name', true);
                          }}
                          mode="dropdown">
                          <Picker.Item
                            label="জেলা নির্বাচন করুনঃ–"
                            value=""
                            color="red"
                          />
                          {district.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.district_name_bng?.toString()}
                              value={item.geo_district_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.district_name && errors.district_name && !searchDistrict_id ? (
                        <ErrorText>{errors.district_name}</ErrorText>
                      ) : null}
                    </View>
                    <Pressable style={styles.submitButton} onPress={handleSearch}>
                      <Text style={styles.submitButtonText}>Search</Text>
                    </Pressable>
                  </View>
                </>
              )}
            </Formik>

            <FlatList
              data={allData}
              keyExtractor={item => item.id.toString()}
              renderItem={renderItem}
              showsVerticalScrollIndicator={true}
              scrollEnabled={true}
            />
          </View>
        </View>
      </View>

      {/* Edit Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={isEditModalVisible}
        onRequestClose={() => setIsEditModalVisible(false)}>
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <Text style={styles.modalTitle}>Edit Data</Text>

            {/* Division Picker */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Division</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDivisionId || ''}
                  style={styles.modalPicker}
                  onValueChange={async (itemValue) => {
                    setEditDivisionId(itemValue);
                    await fetchEditDistrictData(itemValue);
                    setEditDistrictId('');
                  }}
                  mode="dropdown">
                  <Picker.Item
                    label="বিভাগ নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {division.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.division_name_bng?.toString()}
                      value={item.geo_division_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            {/* District Picker */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>District</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDistrictId || ''}
                  style={styles.modalPicker}
                  onValueChange={(itemValue) => {
                    setEditDistrictId(itemValue);
                  }}
                  mode="dropdown">
                  <Picker.Item
                    label="জেলা নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {editDistrictData.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.district_name_bng?.toString()}
                      value={item.geo_district_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            {/* Lower Court Input */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Lower Court Name</Text>
              <View style={styles.modalInputWrapper}>
                <TextInput
                  placeholder="অধস্তন আদালত লিখুন"
                  placeholderTextColor="#999"
                  style={styles.modalTextInput}
                  value={editLowerCourtName}
                  onChangeText={setEditLowerCourtName}
                />
              </View>
            </View>

            {/* Modal Buttons */}
            <View style={styles.modalButtonContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.cancelButton]}
                onPress={() => setIsEditModalVisible(false)}>
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.updateButton]}
                onPress={handleUpdateData}>
                <Text style={styles.updateButtonText}>Update</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  formWrapper: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 12,
    marginBottom: 12,
    paddingVertical: 24,
    paddingHorizontal: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    backgroundColor: '#ffffff',
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#e8eefc',
    shadowColor: '#0f172a',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.08,
    shadowRadius: 20,
    elevation: 8,
  },
  FormGroup: {
    marginBottom: 14,
    marginHorizontal: 8,
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 4,
    backgroundColor: '#fff',
    overflow: 'hidden',
    height: Platform.OS === 'web' && windowWidth >= 600 ? 30 : 30,
  },
  picker: {
    height: Platform.OS === 'web' && windowWidth >= 600 ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  picker2: {
    height: Platform.OS === 'web' && windowWidth >= 600 ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  submitButton: {
    backgroundColor: '#007bff',
    paddingVertical: 5,
    paddingHorizontal: 24,
    borderRadius: 4,
    alignSelf: 'flex-start',
    marginLeft: '2%',
  },
  submitButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  inputWrapper: {
    borderWidth: 2,
    borderColor: '#000',
    borderRadius: 4,
    backgroundColor: '#fff',
    height: 30,
    justifyContent: 'center',
    paddingHorizontal: 0,
  },
  textInput: {
    width: '100%',
    height: 40,
    color: '#333',
    fontSize: 14,
    paddingHorizontal: 8,
  },
  wrapper: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 24,
    marginBottom: 20,
    paddingVertical: 20,
    paddingHorizontal: 16,
    backgroundColor: '#fff',
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#e8eefc',
    shadowColor: '#0f172a',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.08,
    shadowRadius: 20,
    elevation: 8,
  },
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 14,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: '#e5e7eb',
    borderRadius: 10,
    marginBottom: 10,
    backgroundColor: '#fff',
  },
  serial: {
    fontSize: 15,
    fontWeight: '700',
    color: '#111827',
    width: 30,
  },
  content: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
  },
  name: {
    flex: 1,
    fontSize: 15,
    color: '#111827',
    fontWeight: '500',
    marginRight: 10,
  },
  status: {
    fontSize: 14,
    fontWeight: '700',
  },

  // Modal Styles
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 20,
    width: '90%',
    maxWidth: 500,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: '#333',
  },
  modalFormGroup: {
    marginBottom: 15,
  },
  modalLabel: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 5,
    color: '#333',
  },
  modalPickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  modalPicker: {
    height: 50,
    width: '100%',
    color: '#333',
  },
  modalInputWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
  },
  modalTextInput: {
    height: 50,
    paddingHorizontal: 12,
    fontSize: 16,
    color: '#333',
  },
  modalButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    gap: 10,
  },
  modalButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  cancelButton: {
    backgroundColor: '#f5f5f5',
    borderWidth: 1,
    borderColor: '#ddd',
  },
  cancelButtonText: {
    color: '#666',
    fontSize: 16,
    fontWeight: '600',
  },
  updateButton: {
    backgroundColor: '#007bff',
  },
  updateButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
});